import { Observable } from 'rxjs';
import { Participant } from './participant';

export abstract class ParticipantRepository {
  abstract getAll(): Observable<Participant[]>;
  abstract getByDispositifId(dispositifId: number): Observable<Participant[]>;
  abstract create(participant: Participant): Observable<Participant>;
  abstract update(participant: Participant): Observable<Participant>;
  abstract delete(id: number): Observable<void>;
}
